import { ImportPage } from '@/pages/import'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/import')({
  component: ImportPage,
})
